import AppRecord from './AppRecord.js'
import APP from '../../../main.js'

class OnboardingStepDatum extends AppRecord {
  get formattedValue(){
    if (! this.value){
      return this.value
    }

    var test_value = String(this.value).trim()

    // if (this.field_type == 'integer' && parseInt(this.value)){
    //   return parseInt(this.value)
    // } else 
    if ((this.field_type == 'key_lookup' || this.field_type == 'key_exclusive') && parseInt(test_value)){
      return parseInt(test_value)
    }

    return test_value
  }

  valid(value){
    let ret = true
    if (this.required && !value){
      return false
    }

    if (!this.required && !value){
      return true
    }

    // Special handling of values
    switch (this.table) {
      case 'clients':
        switch (this.field) {
          case 'cpr':
            if (value){
              if (value.length != 10){
                ret = false
              } else {
                if(!(/^\d{10}$/).test(value)){
                  ret = false
                }
              }
            }
            break;
          default:
            break;
        }
        break;
      case 'entities':
        switch (this.field) {
          case 'cvr':
            if (value && value.startsWith('DK')) {
              if (!(/^[A-Z]{2}\d{8}$/).test(value)) {
                ret = false
              }
            }
            break;
        
          default:
            break;
        }
        break
      case 'contact_information':
        switch (this.field) {
          case 'info':
            break
        }
        break;
      default:
        break;
    }

    switch (this.field_type) {
      case 'integer':
        if (! /^[0-9]+$/.test(value.replace(/ /g,''))){
          ret = false
        }
        break
      case 'float':
        if (isNaN(value)){
          ret = false
        }
        break
      default:
        break
    } 

    return ret
  }

  translatedField(){
    if (this.label) {return this.label}
   
    if (this.table){
      let controller = Object.values(this.constructor.employeeStore.controllers).find(cc => cc.collection_name === this.table.toLowerCase())
      if (controller){
        return controller.translatedField(this.field)
      }
   }

    if (this.field){
      return this.field
    }

    return ""
  }
}

export default OnboardingStepDatum